<template>
  <div class="publish-article">
    <div class="edit">
      <input type="text" v-model="title" placeholder="请输入标题，为了更好的展示效果，建议标题字数在30字以内" />
      <!-- <label>
        <span>0</span> / 30
      </label>-->
    </div>
    <!-- <div class="edit">
      <input type="text" v-model="keyWords" placeholder="标签关键词（关键词之间请用逗号英文“，”隔开，准确的关键词更容易得到推荐" />
    </div>-->
    <div class="edit">
      <input type="text" v-model="keyWords" placeholder="职位关键词（关键词之间请用逗号英文“，”隔开，准确的关键词更容易得到推荐" />
    </div>
    <!-- 富文本编辑框 -->
    <div class="textbox">
      <div ref="editor" class="tinymce"></div>
    </div>
    <p style="margin-top:5px;color:red;font-size:16px">注意事项:复制微信公众号的图文，图片未显示，需要鼠标点击编辑器外框空白处即可显示文章内图片。</p>
    <div class="publish-classify">
      <label>联系电话</label>
      <input type="text" v-model="phone" class="check-phone" />
    </div>
    <div class="publish-classify">
      <label>城市</label>
      <div class="type" @click.stop="typeSlide">
        <span v-text="cityName"></span>
        <i class="iconfont icon-triangle-down"></i>
      </div>
      <ul v-if="typeShow" class="type-list">
        <li
          v-for="(item,index) in typeName"
          v-if="item.cityName != '全部'"
          :key="index"
          @click.stop="name(item.cityName,item.id)"
        >{{item.cityName}}</li>
      </ul>
    </div>

    <div class="publish-classify" style="height:auto;overflow:hidden;">
      <label>详细地址</label>
      <textarea v-model="address"></textarea>
    </div>
    <div class="publish-classify cover">
      <label>封面</label>
      <ul class="type">
        <li>
          <i
            :class="['iconfont','icon-danxuananniu',isAuto?'active':'']"
            @click.stop="checkAuto('auto')"
          ></i>
          自动
          <span class="iconfont icon-wenhao" @click.stop="autoShow"></span>
        </li>
        <li>
          <i
            :class="['iconfont','icon-danxuananniu',!isAuto?'active':'']"
            @click.stop="checkAuto('loney')"
          ></i>
          单图模式
          <span class="iconfont icon-wenhao" @click.stop="singleShow"></span>
        </li>
      </ul>
      <div v-if="auto" class="automatic auto-a">上传大图能获得更多的推荐机会，建议使用570*390大小的png、jpg图片。</div>
      <div v-if="single" class="automatic auto-b">上传大图能获得更多的推荐机会，建议使用570*390大小的png、jpg图片。</div>
    </div>
    <div class="add-cover">
      <div class="cover-img demo-image__preview">
        <el-image style="width: 220px; height: 130px" :src="coverImg" :preview-src-list="srcList"></el-image>
      </div>
      <label class="preview" for="input">
        <input type="file" id="input" @change="getFile($event)" hidden />
        上传图片
      </label>
    </div>
    <div class="save-btn">
      <div class="btn-list active" @click="senseWord()" v-text="pubName">发布</div>
      <div v-if="isdraf" class="btn-list active"  @click="senses(4)">保存草稿</div>
      <div class="btn-list active" @click="lookCont">客户端浏览</div>
    </div>
    <div class="time-preview" v-if="isLook">
      <div class="zhezhao"></div>
      <div class="pc-preview">
        <div class="closeSee" @click="closeLook">关闭</div>
        <div class="page-table">
          <div class="head-cont">
            <div class="nimei">
              <div class="post-name" v-html="title"></div>
              <!-- <p class="key" v-html="keyWords"></p> -->
              <!-- <p class="site" style="margin-top:10px;"><span v-html="cityName"></span><span v-html="address"></span></p> -->
              <div class="article">
                <p class="content" v-html="editHtmls"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var newHtml;
import $ from "jquery";
import E from "wangeditor";
import { stringify } from "querystring";
import axios from "axios";
import { createHash } from "crypto";
import { log } from 'util';
export default {
  data() {
    return {
      pubName: "发布",
      typeShow: false,
      topShow: false,
      cityName: "",
      cityId: "",
      id: this.$route.query.id || "",
      status: this.$route.query.status || 4,
      typeName: [],
      title: "",
      keyWords: "",
      se: [],
      sensi: [],
      keys: [],
      seaddress: [],
      address: "",
      phone: "",
      auto: false,
      single: false,
      isAuto: true,
      isSingle: true,
      coverImg: require("../../assets/img/cover.png"),
      srcList: [],
      editImg: [],
      number: 0,
      editCon: [],
      isLook: false,
      editHtmls: "",
      isdraf: true,
      number:0
    };
  },
  mounted() {
    console.log(this.status)
    if (this.status == 1) {
      this.pubName = "保存";
      this.isdraf = false;
    }
    this.wangEdit();
    this.getList();
    this.getPublishSum();
     if(this.id){
      this.$store.commit("postpubId", { data: this.id });
      this.setEdit(this.id);
    }else{
      this.setEdit(this.$store.state.postId);
    }
  },
  methods: {
    getPublishSum() {
      this.$http
        .get("/api/media/015-getPublishSum", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.number = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    codeShow() {
      this.topShow = !this.topShow;
    },
    lookCont() {
      this.isLook = true;
      this.editHtmls = this.editor.txt.html();
    },
    closeLook() {
      this.isLook = false;
    },
    // 编辑
    setEdit(id) {
      this.$http
        .get("/api/zhaoPin/zhaoPinDetails", {
          params: {
            id: id,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "详情");
          if (res.status == 200 && res.data.code == 0) {
            this.editCon = res.data.rows[0];
            this.title = this.editCon.title;
            this.keyWords = this.editCon.tags;
            this.address = this.editCon.address;
            this.phone = this.editCon.phone;
            this.editor.txt.html(this.editCon.des);
            // newHtml = this.editCon.des;
            this.cityName = this.editCon.cityName;
            this.cityId = this.editCon.cityId;
            this.coverImg = this.editCon.picUrl;
                      function HTMLEncode(html) {
              var temp = document.createElement("div");
              (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
              var output = temp.innerHTML;
              temp = null;
              return output;
          }
          newHtml = HTMLEncode(this.editCon.des)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    typeSlide() {
      this.typeShow = !this.typeShow;
    },
    name(cityName, cityId) {
      this.typeShow = false;
      this.cityName = cityName;
      this.cityId = cityId;
    },
    autoShow() {
      this.auto = !this.auto;
      this.single = false;
      const fn = () => {
        this.auto = !this.auto;
        document.removeEventListener("click", fn);
      };
      document.addEventListener("click", fn, false);
    },
    singleShow() {
      this.auto = false;
      this.single = !this.single;
      const fn = () => {
        this.single = !this.single;
        document.removeEventListener("click", fn);
      };
      document.addEventListener("click", fn, false);
    },
    checkAuto(type) {
      this.isAuto = !this.isAuto;
      if (type == "auto") {
        console.log(this.editImg[0]);
        this.coverImg = this.editImg[0];
        this.srcList = [this.editImg[0]];
      }
      if (type == "loney") {
        this.coverImg = require("../../assets/img/cover.png");
        this.srcList = [];
      }
    },
    getList() {
      this.$http
        .get("/api/zhaoPin/cityList")
        .then(res => {
          console.log(res, "城市列表");
          if (res.status == 200) {
            this.typeName = res.data.rows;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    upload() {
      $("#input").click();
    },
    getFile(e) {
      console.log(e);
      console.log(e.target.files);
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传图片");
        if (res.status == 200) {
          this.coverImg = res.data.url;
          this.srcList = [res.data.url];
        }
      });
    },
    wangEdit() {
      let editor = new E(this.$refs.editor);
      this.editor = editor;
      editor.customConfig.onfocus = html => {     
        editor.customConfig.onblur = html =>{
          var focusUrl = $(newHtml_before).find('img').attr('src')
          this.coverImg = focusUrl;
          this.srcList[0] = focusUrl;
        };  
      }
      editor.customConfig.onblur = html => {
      var addSrc = "http://img01.store.sogou.com/net/a/04/link?appid=100520029&url=";
      var headerSrc = "https://mmbiz.qpic.cn";
      var src =  $(html).find("img").attr("src");
       var newHtml_before;
        if (src && src.indexOf(addSrc) == -1 && src.indexOf(headerSrc) != -1) {
             newHtml_before =  html.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function(match,capture) {
                var newStr = '<img src="'+ addSrc + capture +'" alt="" />';
　　               return newStr;
            });

          }else{
            newHtml_before = html
          }
          this.editor.txt.html(newHtml_before)
          function HTMLEncode(html) {
              var temp = document.createElement("div");
              (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
              var output = temp.innerHTML;
              temp = null;
              return output;
          }
        newHtml = HTMLEncode(newHtml_before);
        this.editImg = [];
        this.editImg.push($(newHtml_before).find("img").attr("src"));
        this.coverImg = this.editImg[0];
        this.srcList = [this.editImg[0]];
      };
      editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
      editor.customConfig.uploadFileName = "file";
      editor.customConfig.uploadImgServer =
        "https://admin.jzda001.com/tools/uploadFileForJson"; //换成后端给你的上传图片的接口
      editor.customConfig.uploadImgHooks = {
        before: function(xhr, editor, files) {
          let formdata = new FormData();
          for (let i = 0; i < files.length; i++) {
            let url = files[i];
            formdata.append("file", url);
          }
        },
        customInsert: function(insertImg, result, editor) {
          console.log(result);
          let url = result.url;
          insertImg(url);
        }
      };
      editor.create();
    },
    senseWord(sta) {
      if (this.number >= 8) {
        this.$message("一天最多可以发布8次哦~");
        return false;
      }
      //敏感词汇
      this.se = [];
      this.sensi = [];
      this.keys = [];
      this.seaddress = [];
      this.$http
        .get("/api/media/012--sensitivewordList", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            var self = this;
            $.each(res.data.rows, function(k, v) {
              self.se.push(self.title.indexOf(v.keyWord));
              self.sensi.push(newHtml.indexOf(v.keyWord));
              self.keys.push(self.keyWords.indexOf(v.keyWord));
              self.seaddress.push(self.address.indexOf(v.keyWord));
            });
            if (
              self.se.indexOf(0) != -1 ||
              self.sensi.indexOf(0 || 3) != -1 ||
              self.keys.indexOf(0) != -1 ||
              self.seaddress.indexOf(0) != -1
            ) {
              this.$message("很抱歉,您发布的内容含有敏感词汇,无法上传");
            } else {
              var mreg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
              if (this.title == "") {
                this.$message("标题不能为空");
                return false;
              }
              if (this.keyWords == "") {
                this.$message("关键词不能为空");
                return false;
              }
              if (newHtml == "") {
                this.$message("发布内容不能为空");
                return false;
              }
              if (this.phone == "") {
                this.$message("电话不能为空");
                return false;
              }
              if (!mreg.test(this.phone)) {
                this.$message("请输入正确的手机号或座机号");
                return false;
              }
              if (this.address == "") {
                this.$message("地址不能为空");
                return false;
              }
              if (this.cityId == "") {
                this.$message("分类不能为空");
                return false;
              }
              if (this.coverImg == "") {
                this.$message("封面图不能为空");
                return false;
              }
              if (this.id) {
                this.editPub(null);
              } else {
                this.pub(null);
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    pub(sta) {
      //发布
      this.$http
        .post("/api/media/009-zhaopinSave", {
          title: this.title,
          subTitle: 0,
          picUrl: this.coverImg,
          tags: this.keyWords,
          des: newHtml,
          address: this.address,
          phone: this.phone,
          cityName: this.cityName,
          cityId: this.cityId,
          userId: this.$store.state.userInfo.id,
          status: sta,
          token: this.$store.state.userInfo.token
        })
        .then(res => {
          // console.log(res, "发布");
          if (res.data.code == 0) {
            this.$parent.num++;
            this.$message("发布成功");
            this.title = "";
            this.keyWords = "";
            this.address = "";
            this.phone = "";
            this.cityName = "";
            newHtml = "";
            this.editor.txt.html('');
            this.cityId = "";
            this.coverImg = require("../../assets/img/cover.png");
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    senses(four) {
      if (this.number >= 8) {
        this.$message("一天最多可以发布8次哦~");
        return false;
      }
      //敏感词汇
      this.se = [];
      this.sensi = [];
      this.keys = [];
      this.seaddress = [];
      this.$http
        .get("/api/media/012--sensitivewordList", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            var self = this;
            $.each(res.data.rows, function(k, v) {
              self.se.push(self.title.indexOf(v.keyWord));
              self.sensi.push(newHtml.indexOf(v.keyWord));
              self.keys.push(self.keyWords.indexOf(v.keyWord));
              self.seaddress.push(self.address.indexOf(v.keyWord));
            });
            if (
              self.se.indexOf(0) != -1 ||
              self.sensi.indexOf(0 || 3) != -1 ||
              self.keys.indexOf(0) != -1 ||
              self.seaddress.indexOf(0) != -1
            ) {
              this.$message("很抱歉,您发布的内容含有敏感词汇,无法上传");
            } else {
              var mreg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
              if (this.title == "") {
                this.$message("标题不能为空");
                return false;
              }
              if (this.keyWords == "") {
                this.$message("关键词不能为空");
                return false;
              }
              if (newHtml == "") {
                this.$message("发布内容不能为空");
                return false;
              }
              if (this.phone == "") {
                this.$message("电话不能为空");
                return false;
              }
              if (!mreg.test(this.phone)) {
                this.$message("请输入正确的手机号或座机号");
                return false;
              }
              if (this.address == "") {
                this.$message("地址不能为空");
                return false;
              }
              if (this.cityId == "") {
                this.$message("分类不能为空");
                return false;
              }
              if (this.coverImg == "") {
                this.$message("封面图不能为空");
                return false;
              }
              if (this.id) {
                this.editPub(four);
              } else {
                this.pub(4);
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    editPub(four) {
      console.log('000');
      console.log(typeof newHtml)
      this.$http
        .post("/api/media/009-zhaopinEdit", {
          id: this.id,
          title: this.title,
          subTitle: 0,
          picUrl: this.coverImg,
          tags: this.keyWords,
          des: newHtml,
          address: this.address,
          phone: this.phone,
          cityName: this.cityName,
          cityId: this.cityId,
          status: four,
          userId: this.$store.state.userInfo.id
        })
        .then(res => {
          // console.log(res, "发布");
          if (res.data.code == 0) {
            this.$parent.num++;
            this.$message("发布成功");
            this.title = "";
            this.keyWords = "";
            this.address = "";
            this.phone = "";
            this.cityName = "";
            newHtml = "";
            this.editor.txt.html('');
            this.cityId = "";
            this.coverImg = require("../../assets/img/cover.png");
            this.$router.push("/inviteManage");
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
/* .publish .btn-list {
  margin: 0px auto;
  float: none;
} */
.publish .save-btn {
  margin: 80px auto 30px;
}
.publish .publish-classify textarea {
  float: left;
  border: 1px solid #ccc;
  width: 300px;
  height: 100px;
  resize: none;
  border-radius: 2px;
}
.check-phone {
  float: left;
  padding-left: 10px;
  height: 38px;
  width: 160px;
  border: 1px solid #ccc;
}
.time-preview {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.pc-preview {
  width: 550px;
  height: 720px;
  margin: 0px auto;
  position: fixed;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.closeSee {
  width: 30px;
  height: 30px;
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 999;
  color: #000;
  cursor: pointer;
}
.page-table {
  width: 380px;
  height: 730px;
  margin: 50px auto 0px;
  border-radius: 15px;
  z-index: 1000;
  padding-bottom: 40px;
  overflow: hidden;
  background: url(../../assets/img/ph.png) no-repeat;
  background-size: 100% 100%;
}
.head-cont {
  width: 300px;
  height: calc(100% - 65px);
  overflow: hidden;
  margin: 60px auto 0px;
}
.head-cont .nimei{
  width:320px;
  height:100%;
  box-sizing: content-box;
  padding-right:30px;
  overflow-y: auto;
  overflow-x: hidden;
}
.head-cont .post-name {
  color: #1f1407;
  margin-top: -3px;
  text-align: left;
  font-size: 17px;
}
.head-cont .key {
  color: #999;
  font-size: 14px;
  margin-top: 8px;
}
.sea-list {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-top: 20px;
}
.sea-list .new-img {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  margin-right: 10px;
  overflow: hidden;
  float: left;
}
.sea-list .time {
  width: calc(100% - 50px);
  float: left;
  line-height: 32px;
  font-size: 12px;
  color: #999;
}
.sea-list .time span {
  color: #2e8043;
}
.sea-list::after {
  content: "";
  display: block;
  clear: both;
  width: 100px;
  height: 1px;
  background: #ededed;
}
.article {
  margin-top: 15px;
}
</style>
<style>
.w-e-text-container {
  height: 530px !important;
  border-color: #ccc !important;
  z-index: 1 !important;
}
.w-e-toolbar {
  z-index: 1 !important;
}
.w-e-toolbar .w-e-menu {
  z-index: 2 !important;
}
.el-input__inner {
  border: 1px solid #999 !important;
}
</style>
